import React from 'react';
import { Col } from 'react-bootstrap';

interface PageInfoProps {
  total: number;
  page: number;
  size: number;
  items: any[];
}

export const PageInfo = ({ total, page, size, items }: PageInfoProps) => {
  const offset = page * size;
  const from = offset + 1;
  const to = offset + (size > items.length ? items.length : size);
  const totalPages = Math.ceil(total / size);
  if (totalPages <= 1) {
    return null;
  }
  return (
    <Col as='p' className='mb-0'>
      Showing {from} to {to > total ? total : to} of {total} items
    </Col>
  );
};

export default PageInfo;
